export default __webpack_public_path__ + "assets/images/8b905934109193409fc940d2f3beaa90.png";